import React from 'react'
import { BarChart, FloorPlanSummaryReport } from '@components/custom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import './BarChartsContainer.scss'
import { PageTitleBar } from '@components/common'

class BarChartsContainer extends React.Component {
  // Getting deep copy to avoid cyclic object creation by Bar component
  getCopyOfChartData(chartData) {
    const chartDataDeepCopy = {
      datasets: [
        {
          backgroundColor: chartData.datasets[0].backgroundColor,
          borderWidth: chartData.datasets[0].borderWidth,
          data: chartData.datasets[0].data
        }
      ],
      labels: chartData.labels,
      yaxisConfig: { ...chartData.yaxisConfig }
    }

    return chartDataDeepCopy
  }

  pareTwoPerPageBarCharts(layoutOptions) {
    const paredTwoPerPageLayoutArr = []
    for (let i = 0; i < layoutOptions.length; i += 1) {
      const currentLayoutObj = layoutOptions[i]
      let nextLayoutObj
      if (i + 1 <= layoutOptions.length) {
        nextLayoutObj = layoutOptions[i + 1]
      }
      if (
        currentLayoutObj.layout === 2 &&
        (nextLayoutObj && nextLayoutObj.layout === 2)
      ) {
        paredTwoPerPageLayoutArr.push([currentLayoutObj, nextLayoutObj])
        i += 1
      } else {
        paredTwoPerPageLayoutArr.push(currentLayoutObj)
      }
    }

    return paredTwoPerPageLayoutArr
  }

  displayBarChart(chartDataObj, chartSettings) {
    const { isGrid, propertyNameOrientation, isValueOrientation, barWidth } = chartSettings

    return (
      <BarChart
        editBarChartSettings={this.props.editBarChartSettings}
        chartData={this.getCopyOfChartData(chartDataObj.chartData)}
        defaultChartOptions={chartDataObj.chartOptions}
        pageTitle={chartDataObj.pageTitle}
        isGrid={isGrid}
        propertyNameOrientation={propertyNameOrientation}
        isValueOrientation={isValueOrientation}
        barWidth={barWidth}
      />
    )
  }

  prepareCustomBarCharts(props) {
    const {
      toggleSettings: { hasBranding, hasPageTitle },
      barChartData,
      barChartSettings: { isGrid, isValueOrientation, propertyNameOrientation, barWidth },
      templateName,
      themeColors,
      fpSummaryData
    } = props

    const barChartLayoutOptions = fpSummaryData ? this.props.barChartSettings.fpbarChartLayoutOptions : this.props.barChartSettings.barChartLayoutOptions
    const layoutOptions = barChartLayoutOptions.filter(obj => obj.layout !== 0)
    const paredLayoutOptions = this.pareTwoPerPageBarCharts(layoutOptions)
    const container = []
    paredLayoutOptions.forEach(layoutObj => {
      if (layoutObj.length) {
        const element = (
          <div className="bar-chart-page">
            <PageTitleBar templateName={templateName} hasBranding={hasBranding} themeColors={themeColors} />
            <div className="two-halves">
              {layoutObj.map((halfLayout, index) => {
                const chartDataObj = barChartData.find(dataObj => dataObj.pageTitle === halfLayout.pageTitle)

                return (
                  <div key={index} className="half">
                    {this.displayBarChart(chartDataObj, { isGrid, propertyNameOrientation, isValueOrientation, barWidth })}
                  </div>
                )
              })}
            </div>
          </div>
        )
        container.push(element)
      } else {
        const classes = layoutObj.layout === 2 ? 'half' : ''
        const chartDataObj = barChartData.find(dataObj => dataObj.pageTitle === layoutObj.pageTitle)
        const summaryDataObj = fpSummaryData && fpSummaryData.find(dataObj => dataObj.pageTitle === layoutObj.pageTitle)
        const element = chartDataObj ?
          (
            <div className="bar-chart-page">
              <PageTitleBar templateName={templateName} hasPageTitle={hasPageTitle} hasBranding={hasBranding} themeColors={themeColors} />
              <div className={classes}>
                {this.displayBarChart(chartDataObj, { isGrid, propertyNameOrientation, isValueOrientation, barWidth })}
              </div>
            </div>
          )
          :
          (
            <>
              {summaryDataObj &&
                <FloorPlanSummaryReport
                  summarydata={summaryDataObj.summary}
                  pageTitle={layoutObj.pageTitle}
                  hasBranding={hasBranding}
                  hasPageTitle={hasPageTitle}
                  type={summaryDataObj.type}
                />
              }
            </>
          )
        container.push(element)
      }
    })

    return container
  }

  render() {
    const container = this.prepareCustomBarCharts(this.props)
    const {
      toggleSettings: { hasBranding, hasPageTitle }
    } = this.props

    return (
      <div
        className={(hasBranding || hasPageTitle) ? 'bar-chart-container' : 'no-margin-bar-chart-container'}
        data-testid="bar-charts-container"
        id="#property_barcharts"
      >
        {container.map((obj, index) => (
          <div key={index}>
            {obj}
          </div>
        ))}
      </div>
    )
  }
}

BarChartsContainer.propTypes = {
  editBarChartSettings: PropTypes.func,
  toggleSettings: PropTypes.shape({
    hasBranding: PropTypes.bool
  }),
  barChartSettings: PropTypes.shape({
    isGrid: PropTypes.string,
    isValueOrientation: PropTypes.string,
    propertyNameOrientation: PropTypes.string,
    barChartLayoutOptions: PropTypes.array,
    fpbarChartLayoutOptions: PropTypes.array
  }),
  barChartData: PropTypes.array,
  templateName: PropTypes.string,
  themeColors: PropTypes.object,
  editThemeColors: PropTypes.func
}

const mapStateToProps = state => ({
  barChartSettings: Comps.selectors.comps.barChartSettings(state),
  // toggleSettings: Comps.selectors.comps.toggleSettings(state),
  // barChartData: Comps.selectors.comps.barChartData(state),
  templateName: Comps.selectors.comps.templateName(state),
  themeColors: Comps.selectors.comps.themeColors(state)
})
const mapDispatchToProps = {
  editBarChartSettings: Comps.actions.editBarChartSettings,
  editThemeColors: Comps.actions.editThemeColors
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BarChartsContainer)
